import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.scss';
import Icon, { GLYPHS } from '../../../../../app/common/icon';
import { formatNumber } from '../../../../../app/common/money';
import { getCustomerGroupsViewConfig } from '../customer-groups-view-config';
import { RoleAwareLink } from '../../../../infra/ui/role-aware-link';
import { t } from '../../../../infra/i18n';
export var CustomerGroupCard = function (_a) {
    var customerCount = _a.customerCount, groupName = _a.groupName;
    var customerGroupsViewConfig = getCustomerGroupsViewConfig();
    var GroupIcon = customerGroupsViewConfig[groupName].IconComponent;
    return (_jsxs("div", { className: styles.card, children: [_jsx("div", { className: styles['customer-icon'], children: _jsx(GroupIcon, {}) }), _jsx("span", { className: styles['customer-count'], children: formatNumber(customerCount, 0) }), _jsx("span", { className: styles['group-name'], children: customerGroupsViewConfig[groupName].displayGroupName }), _jsxs(RoleAwareLink, { id: "create-customer-group-campaign-button-".concat(groupName), className: styles.link, to: {
                    pathname: '/engagement/new',
                    state: { preSelectCustomerGroup: groupName },
                }, children: [t('engage:customer_groups.start_campaign_button'), "\u00A0", _jsx(Icon, { glyph: GLYPHS.chevronLeftBold })] })] }));
};
